import 'react';
import { BsCursor } from '@react-icons/all-files/bs/BsCursor';
import { BsCursorFill } from '@react-icons/all-files/bs/BsCursorFill';
import { decorateComponent } from '../../../documentComponents/decorateComponent.js';
import { AccordionButton as AccordionButton$1 } from './AccordionButton.js';
import { AccordionButtonInspector } from './AccordionButton.Inspector.js';
import { jsx } from '@emotion/react';

var AccordionButton = decorateComponent(AccordionButton$1, 'block', {
  id: 'accordionButton',
  allowedParent: ['accordion'],
  allowedChildren: ['text', 'image', 'block'],
  disabledDelete: true,
  disabledClone: true,
  disabledMove: true,
  renderIcon: function renderIcon(_ref) {
    var action = _ref.action;
    return action === 'expand' ? jsx(BsCursorFill, null) : jsx(BsCursor, null);
  },
  renderTitle: function renderTitle(_ref2) {
    var action = _ref2.action;
    return "\uC544\uCF54\uB514\uC5B8 ".concat(action === 'expand' ? '펼치기' : '접기', " \uBC84\uD2BC");
  },
  renderInspector: AccordionButtonInspector
});

export { AccordionButton as default };
//# sourceMappingURL=index.js.map
